import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-successful',
  templateUrl: './successful.component.html',
  styleUrls: ['./successful.component.scss']
})
export class SuccessfulComponent implements OnInit {
  ngZone: any;

  constructor(private bottomSheetRef: MatBottomSheetRef<SuccessfulComponent>,
      private bottomSheet: MatBottomSheet,) { }

  ngOnInit() {
  }
  copySuccess: boolean  = false;

  copyCoupon(code: string): void {
    navigator.clipboard.writeText(code).then(() => {
      this.copySuccess = true;
      setTimeout(() => {
        this.copySuccess = false;
      }, 2000); // hide after 2 seconds
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }
  

  closeSheet(): void {
    this.bottomSheetRef.dismiss();
  }
}
